// covered-by: frontends/carrie/src/utils/__tests__/useStartNewProjectChat.test.ts
// why: must match christo PLACEHOLDER_PROJECT_NAME
// (services/christo/lib/services/askPunttChatTitle.ts) or untitled projects
// never rename — renamePlaceholderProjectFromUserTurn only touches rows whose
// name equals christo's literal. A frontends/ -> services/ import is
// forbidden, so both sides pin the string instead: this one in
// frontends/carrie/src/utils/__tests__/useStartNewProjectChat.test.ts and
// christo's in services/christo/lib/services/askPunttChatTitle.spec.ts. A
// one-sided edit reds one of the two.
export const PLACEHOLDER_PROJECT_NAME = "New project";
